/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type PolarisCollectionsPageType from '@jira/spa-apps__polaris-collections/src/index.tsx';
import { useIsCrossProjectViewsEnabled } from '@jira/polaris__lib-entitlement-utils/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import { Redirect } from '@atlassian/react-resource-router';

export const LazyCollectionsPage: LazyComponent<{
	(props: React.RefAttributes<unknown>): React.JSX.Element;
	displayName: string;
}> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PolarisCollectionsPageType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-polaris-collections", jiraSpaEntry: "async-polaris-collections" */ '@jira/spa-apps__polaris-collections/src/index.tsx'
				),
			),
		{ ssr: false },
	);

const useJpdLicensed = () => {
	const context = useTenantContext();
	return context.licensedProducts['jira-product-discovery'];
};

export const RedirectingCollectionsPage = (): React.JSX.Element => {
	const jpdLicensed = useJpdLicensed();
	const crossProjectViewsEnabled = useIsCrossProjectViewsEnabled();

	if (!jpdLicensed) {
		return <Redirect to="/jira/polaris/unlicensed" />;
	}

	if (!crossProjectViewsEnabled) {
		return <Redirect to="/jira" />;
	}

	return (
		<LazyPage
			Page={LazyCollectionsPage}
			pageId="async-polaris-collections"
			shouldShowSpinner={false}
		/>
	);
};

export default RedirectingCollectionsPage;
